<template>
  <div>
    <paypal-logo-black class="w-24" />
  </div>
</template>

<script>
import PaypalLogoBlack from '../../logos/PaypalLogoBlack.vue';

export default {
  components: { PaypalLogoBlack },

};
</script>
